import { SVGProps } from 'react';

export const LightningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
    <path d="M13 2L4.5 13.5H11l-1 8.5L19.5 10.5H13L13 2z" fill="currentColor" />
  </svg>
);
